module.exports = __webpack_public_path__ + "static/media/wh1.7b81e021.png";